import getVehicleDataPush from "../utils/getVehicledataPush";
import { Items as VehicleInformation } from "../vehicle-search-details/vehicleSearch.type";

interface BatteryReportDataPushPropTypes {
  mechReportCombo: string;
  isTracked: boolean;
  note: string;
  catalogueRef: string | string[];
  section?: string;
  vehicleInfo?: VehicleInformation;
}

export const batteryReportDataPush = ({
  mechReportCombo,
  isTracked,
  note,
  catalogueRef,
  section = "",
  vehicleInfo,
}: BatteryReportDataPushPropTypes) => {
  //@ts-ignore
  if (window.digitalData) {
    let vehicleDataPush;

    vehicleDataPush = getVehicleDataPush(
      vehicleInfo,
      catalogueRef,
      isTracked,
      note,
      mechReportCombo
    );

    let result: {
      event;
      product;
    } = {
      event: {
        name: "click",
        category: "button",
        label: "ev-battery|overlay",
        action: "open",
        section,
        value: "",
      },
      product: {
        ...vehicleDataPush,
      },
    };

    //@ts-ignore
    return digitalData.push(result);
  }
};
